import { render, staticRenderFns } from "./RHCard.vue?vue&type=template&id=3867e421&scoped=true"
import script from "./RHCard.vue?vue&type=script&lang=js"
export * from "./RHCard.vue?vue&type=script&lang=js"
import style0 from "./RHCard.vue?vue&type=style&index=0&id=3867e421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3867e421",
  null
  
)

export default component.exports